<template>
  <main ref="resumen" id="resumen">
    <div class="card mt-2 shadow-none" v-if="isLoading">
      <div class="card-body">
        <content-placeholders :rounded="true">
          <content-placeholders-heading :img="false" />
          <content-placeholders-text :lines="3" />
        </content-placeholders>
      </div>
    </div>
    <div v-else>
      <div class="py-2">
        <motivoConsultaShow :idHistoria="idHistoria" :data="resumen.motivo_consulta"></motivoConsultaShow>
      </div>
      <div class="py-2">
        <examenFisicoShow :idHistoria="idHistoria" :examenFisico="resumen.examen_fisico"></examenFisicoShow>
      </div>
      <div class="py-2">
        <exploracionFisicaShow :idHistoria="idHistoria" :data="resumen.exploracion_fisica"></exploracionFisicaShow>
      </div>
      <div class="py-2" v-if="resumen && resumen.ordenes">
        <ordenClinicaShow :idHistoria="idHistoria" :data="resumen.ordenes"></ordenClinicaShow>
      </div>
      <div class="py-2" v-if="resumen && resumen.formulas">
        <formulaMedicaShow :idHistoria="idHistoria" :data="resumen.formulas"></formulaMedicaShow>
      </div>
      <div class="py-2" v-if="resumen && resumen.impresion_diagnostica">
        <impresionDxShow :idHistoria="idHistoria" :data="resumen.impresion_diagnostica"></impresionDxShow>
      </div>
      <div class="py-2" v-if="resumen && resumen.urgencia_revision">
        <revisionSistemasShow :idHistoria="idHistoria" :data="resumen.urgencia_revision"></revisionSistemasShow>
      </div>
      <div v-if="resumen && resumen.riesgo_cardiovascular">
        <div class="card-header bg-light">
          <span><i class="fa fa-syringe"> </i> Riesgo Cardiovascular</span>
        </div>
        <div class="card-body">
          <div class="py-2">
            <riesgoCardiovacular :data="resumen.riesgo_cardiovascular" :idHistoria="idHistoria"></riesgoCardiovacular>
          </div>
        </div>
      </div>
      <div class="py-2" v-if="resumen && resumen.findrisc">
        <finnisRiskShow :idHistoria="idHistoria" :data="resumen.findrisc"></finnisRiskShow>
      </div>
      <div class="py-2" v-if="resumen && resumen.vale">
        <valeShow :idHistoria="idHistoria"
         :data_riesgos="resumen.vale" 
         :condiciones_estructurales="resumen.condiciones_estructurales"
         :items_valoracion="resumen.items_valoracion"></valeShow>
      </div>
      <div class="py-2" v-if="resumen && resumen.usuario">
        <vacunasShow :idHistoria="idHistoria" :data="resumen.usuario"></vacunasShow>
      </div>
      <div class="py-2" v-if="resumen && resumen.situaciones_personales">
        <situacionesPersonalesShow :idHistoria="idHistoria" :idUsuario="idUsuario"
          :data="resumen.situaciones_personales"></situacionesPersonalesShow>
      </div>
      <div class="py-2" v-if="resumen && resumen.tanner">
        <tannerComponentShow :idHistoria="idHistoria" :data="resumen.tanner"></tannerComponentShow>
      </div>
      <div class="py-2" v-if="resumen && resumen.intervenciones">
        <intervencionesShow :idHistoria="idHistoria" :data="resumen.intervenciones"></intervencionesShow>
      </div>
      <div class="py-2" v-if="resumen && resumen.recomendaciones">
        <recomendacionesShow :idHistoria="idHistoria" :data="resumen.recomendaciones"></recomendacionesShow>
      </div>
    </div>
  </main>
</template>

<script>
import motivoConsultaShow from "../../base/motivoConsulta/motivoConsultaShow";
import examenFisicoShow from "../../base/examenFisico/examenFisicoShow";
import ordenClinicaShow from "../../base/orden/ordenClinicaShow";
import formulaMedicaShow from "../../base/formulaMedica/formulaMedicaShow";
import impresionDxShow from "../../base/impresionDX/impresionDxShow";
import exploracionFisicaShow from "../../base/examenFisico/exploracionFisicaShow";
import revisionSistemasShow from "../../base/baseUrgencia/revisionShow";
import riesgoCardiovacular from "../../base/baseRiesgoCardiovascular/riesgosModificableShow";
import finnisRiskShow from "../../base/baseFinnisRisk/finnisRiskShow";
import historiaClinicaService from "../../../../services/historiaClinicaService";
import valeShow from "../../base/baseVale/valeShow";
import vacunasShow from "../../base/baseVacunas/index/vacunasShow";
import situacionesPersonalesShow from "../../base/baseSituacionesPersonales/situacionesPersonalesShow";
import tannerComponentShow from "../../base/baseTanner/tannerComponentShow";
import intervencionesShow from "../../base/intervenciones/intervencionesShow";
import recomendacionesShow from "../../base/recomendaciones/recomendacionesShow";

export default {
  props: ["idHistoria", "idUsuario", "usuario"],
  components: {
    motivoConsultaShow,
    examenFisicoShow,
    ordenClinicaShow,
    formulaMedicaShow,
    impresionDxShow,
    exploracionFisicaShow,
    revisionSistemasShow,
    riesgoCardiovacular,
    finnisRiskShow,
    valeShow,
    vacunasShow,
    situacionesPersonalesShow,
    tannerComponentShow,
    intervencionesShow,
    recomendacionesShow
  },
  data() {
    return {
      resumen: {},
      isLoading: true
    };
  },

  async created() {
    this.isLoading = true;
    const response = await historiaClinicaService.resumenHc(this.idHistoria);
    this.resumen = response.data;
    this.isLoading = false;

  },
};
</script>

<style scoped>
.resumen-container {
  height: 300px;
  overflow-y: scroll;
}
</style>
